import { clsx } from 'clsx';
import * as styles from './styles.css';
import { NAVIGATION } from 'shared/constants/navigation';
import { useDeviceType } from '@cian/ui-kit';
import { Wrapper } from 'shared/components/Wrapper';
import { Block } from 'shared/components/Block';
import { NBSP } from 'shared/constants/symbols';
import { IR_FIN_RESULT_LINK, MAIN_IR_LINK, TG_CHANNEL_LINK } from 'shared/constants/links';

export const Links: React.FC = () => {
  const device = useDeviceType();

  return (
    <div>
      <Wrapper>
        <Block>
          <div className={clsx(styles['title'], styles[device])}>Читайте подробнее о бизнес-модели Циан:</div>
          <div className={clsx(styles['navigation'], styles[device])}>
            {NAVIGATION.map(({ name, links, url }, key) => (
              <div key={key} className={clsx(styles['nav-item'])}>
                <a href={url} className={styles['nav-title']}>
                  {name}
                </a>
                <div className={styles['links']}>
                  {links.map((link, index) => (
                    <div key={index}>
                      {link.title && (
                        <a href={link.title.url} className={styles['link-title']}>
                          {link.title.text}
                        </a>
                      )}
                      <ul className={styles['urls']}>
                        {link.urls.map(({ url, text }, urlIndex) => (
                          <li key={urlIndex}>
                            <a href={url} className={styles['url']}>
                              {text}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
                <a href={url} className={styles['arrow-link']} />
              </div>
            ))}
          </div>
          <div className={clsx(styles['banner'], styles[device])}>
            <div>
              Мы регулярно раскрываем финансовые показатели, ключевые метрики бизнеса и{NBSP}операционные результаты{' '}
              <a className={styles['link']} href={MAIN_IR_LINK} target="_blank" rel="noreferrer">
                на официальном сайте
              </a>{' '}
              и{NBSP}
              <a className={styles['link']} href={TG_CHANNEL_LINK} target="_blank" rel="noreferrer">
                в Telegram-канале
              </a>{' '}
              для инвесторов.
            </div>
            <div>
              Финансовые результаты компании доступны{' '}
              <a className={styles['link']} href={IR_FIN_RESULT_LINK} target="_blank" rel="noreferrer">
                по ссылке.
              </a>
            </div>
          </div>
        </Block>
      </Wrapper>
    </div>
  );
};
